export default "__VITE_ASSET__BCoBBYax__"